import './NewsArticle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

function NewsArticle({ date, title, author, content, link }) {

  return (
    <a className="news-card" href={link} target="_blank" rel="noreferrer">
      <div className="news-card-top">
        <span className="news-card-source">{author}</span>
        <span className="news-card-date">{date}</span>
      </div>
      <h2 className="news-card-title">{title}</h2>
      <p className="news-card-excerpt">{content}</p>
      <div className="news-card-bottom">
        <span className="news-card-read">
          Read Article <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
        </span>
      </div>
    </a>
  );
}

export default NewsArticle;
